require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps.json") })
        }
      }, "path---blog-student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps!./.cache/json/blog-student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps.json
// module id = 1047
// module chunks = 231608221292675